import { createContext } from "react";
import moment from "moment";

export const RefreshFiltersContext = createContext({
  timeStamp: moment().format("MM/DD hh:mm A"),
  func: () => {
    alert("Refresh");
  }
});
